import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
export const editChallengeHolderRequest = createAction('editChallengeHolderRequest');
export const editChallengeHolderSuccess = createAction('editChallengeHolderSuccess');
export const editChallengeHolderFailure = createAction('editChallengeHolderFailure');

export const editChallengeHolder = (
    challengeGroupID: number,
    postbody: EditChallengeHolderRequest,
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(editChallengeHolderRequest());
    try {
        await api.post(`admin/challengeGroups/${challengeGroupID}/attach-holder`, postbody);

        dispatch(editChallengeHolderSuccess());
    } catch (e: any) {
        handleApiErrors(dispatch, editChallengeHolderFailure, e);
    }
};

export interface EditChallengeHolderRequest {
    challengeHolderIDs: number[];
}
